<template>
  <div :class="[prefix,`${prefix}-wrap`]">
    <div
      v-if="visible && announce.Id"
      class="news-container full-box"
    >
      <!-- <span class="icon iconfont iconlaba horn"></span> -->
      <img
        class="horn"
        src="data:image/gif;base64,R0lGODlhEAAOANU2APV1cv/32/iYj/eKg/Z8ePeJg+4ZKP/22v3Zw+4TJO4XJ/AyPfA2QPeTiv7oz/q3p/vDsfE8Rf3YwvA4Qfq8q/iZj/E6Q/AvOu8sN/vEsvvFsv3ky//42+4aKfvItfzLt+8mM/RubPA6Q/mtn/A3QPNWWviglPihlfijl/RiY/eVjPJUV/NZXPiilv7u0/mrnfiXjvNXWv7t0vZ+eu0MHv/53AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkM4NkVFMjUwMUEwNTExRTlCMjNDOEU1MEQ0NjcyOEU4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkM4NkVFMjUxMUEwNTExRTlCMjNDOEU1MEQ0NjcyOEU4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Qzg2RUUyNEUxQTA1MTFFOUIyM0M4RTUwRDQ2NzI4RTgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Qzg2RUUyNEYxQTA1MTFFOUIyM0M4RTUwRDQ2NzI4RTgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4B//79/Pv6+fj39vX08/Lx8O/u7ezr6uno5+bl5OPi4eDf3t3c29rZ2NfW1dTT0tHQz87NzMvKycjHxsXEw8LBwL++vby7urm4t7a1tLOysbCvrq2sq6qpqKempaSjoqGgn56dnJuamZiXlpWUk5KRkI+OjYyLiomIh4aFhIOCgYB/fn18e3p5eHd2dXRzcnFwb25tbGtqaWhnZmVkY2JhYF9eXVxbWllYV1ZVVFNSUVBPTk1MS0pJSEdGRURDQkFAPz49PDs6OTg3NjU0MzIxMC8uLSwrKikoJyYlJCMiISAfHh0cGxoZGBcWFRQTEhEQDw4NDAsKCQgHBgUEAwIBAAAh+QQFFAA2ACwAAAAAEAAOAEAGbsCacFjTLARCV2hUozmfzxlRCIJCCdMsZ+YE1BwLmmnqiTwHgQRNJTRYo7WMZUKKbRASQQdaOKxQWUNcNF4yIjQwNQgPEA1qT30lLUNvcFNulVJyEwwsGAoKb1iBQh8MZ2k0J6Q1FBcVQg4pLzVBACH5BAUUADYALAsAAAAFAA4AQAYNwJpwSCwaj8ikckkMAgA7"
      >
      <span
        class="text"
        :title="announce.Title"
      >{{announce.Title}}</span>
      <span
        class="icon iconfont iconclose close"
        @click="visible=false"
      ></span>
    </div>
  </div>
</template>

<script>
// import { mapState, mapActions } from 'vuex';
import '@/styles/components/news/topNews.scss';
import { mapActions } from 'vuex';
const prefix = 'cpt-top-news';
export default {
  name: 'TopNews',
  data () {
    return {
      prefix,
      visible: true,
      announce: {}
    };
  },
  computed: {
  },
  methods: {
    ...mapActions({
      getLatestAnnounce: 'getLatestAnnounce'
    })
  },
  watch: {
    $route (newVal, oldVal) {
      this.visible = this.$route.path === '/';
    }
  },
  created () {
    // get lastest news
    this.getLatestAnnounce()
      .then(result => {
        if (result.Success && result.Data && result.Data.List.length > 0) {
          this.announce = result.Data.List[0];
        }
      })
      .catch(error => {
        console.log('error:', error);
      });
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/news/TopNews.vue